module.exports = __webpack_public_path__ + "static/img/founder1.feb52fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/founder1.png
// module id = RloP
// module chunks = 0